import React from 'react';
import PropTypes from 'prop-types';
import {
  LOADING_STATE_VALUE,
  NO_RELAY_DEFAULTS,
  REGISTRATION_ATTEMPTS,
  TRACKING_NUMBER_STATUS,
} from '../../constants';
import './_PhoneRegistrationRelayNumbers.scss';

const PhoneRegistrationRelayNumbers = ({
  fieldName,
  propertyPhoneRegistrationRelayMap,
  relayPhones,
}) => {
  if (relayPhones.length === 1) {
    const { relayPhoneId } = relayPhones[0];
    return (
      propertyPhoneRegistrationRelayMap[relayPhoneId]?.[fieldName] ||
      LOADING_STATE_VALUE
    );
  }

  return relayPhones.map((relayPhone) => {
    const registrationRelayPhone =
      propertyPhoneRegistrationRelayMap[relayPhone.relayPhoneId] || {};

    return (
      <span className="relay-number-row" key={relayPhone.relayPhoneId}>
        <span className="relay-number">{`${relayPhone.voiceNumber}: `}</span>
        {registrationRelayPhone[fieldName] || LOADING_STATE_VALUE}
      </span>
    );
  });
};

PhoneRegistrationRelayNumbers.propTypes = {
  fieldName: PropTypes.string,
  propertyPhoneRegistrationRelayMap: PropTypes.objectOf(
    PropTypes.shape({
      [REGISTRATION_ATTEMPTS]: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
      [TRACKING_NUMBER_STATUS]: PropTypes.string,
      [NO_RELAY_DEFAULTS]: PropTypes.shape({
        [REGISTRATION_ATTEMPTS]: PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string,
        ]),
        [TRACKING_NUMBER_STATUS]: PropTypes.string,
      }),
    })
  ),
  relayPhones: PropTypes.arrayOf(
    PropTypes.shape({
      relayPhoneId: PropTypes.number,
      voiceNumber: PropTypes.string,
    })
  ),
};

export default PhoneRegistrationRelayNumbers;
